import {
  TreasuryBankAccountPageRequest as TreasuryBankAccountPageRequestDto,
  TreasuryBankAccountPageResponse,
  TreasuryBankAccountRequest as TreasuryBankAccountRequestDto,
  TreasuryBankAccountResponse,
} from "lib-klab-sdks";
import {
  TreasuryBankAccount,
  TreasuryBankAccountPage,
  TreasuryBankAccountPageRequest,
  TreasuryBankAccountRequest,
} from "../../../domain/models/treasury/bank-account.model";

export function mapTreasuryBankAccount(dto: TreasuryBankAccountResponse): TreasuryBankAccount {
  return {
    id: dto.id,
    supplierId: dto.supplierId,
    ownerUserId: dto.ownerUserId,
    bankId: dto.bankId,
    bankName: dto.bankName,
    accountNumber: dto.accountNumber ?? "",
    cci: dto.cci ?? "",
    currencyId: dto.currencyId,
    currencyCode: dto.currencyCode,
    accountHolder: dto.accountHolder ?? "",
    alias: dto.alias ?? "",
    lastPaymentDate: dto.lastPaymentDate,
    active: dto.active,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
}

export function mapTreasuryBankAccountRequest(
  request: TreasuryBankAccountRequest,
): TreasuryBankAccountRequestDto {
  return {
    supplierId: request.supplierId,
    ownerUserId: request.ownerUserId,
    bankId: request.bankId,
    accountNumber: request.accountNumber,
    cci: request.cci,
    currencyId: request.currencyId,
    accountHolder: request.accountHolder,
    alias: request.alias,
    active: request.active,
  };
}

export function mapTreasuryBankAccountPageRequest(
  request: TreasuryBankAccountPageRequest,
): TreasuryBankAccountPageRequestDto {
  return {
    page: request.page,
    size: request.size,
    ownerUserId: request.ownerUserId,
    supplierId: request.supplierId,
    internalOnly: request.internalOnly,
    search: request.search,
  };
}

export function mapTreasuryBankAccountPage(
  response: TreasuryBankAccountPageResponse,
): TreasuryBankAccountPage {
  return {
    content: response.content.map(mapTreasuryBankAccount),
    page: response.page,
    size: response.size,
    totalElements: response.totalElements,
    totalPages: response.totalPages,
  };
}
